import React, { useEffect, useState } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import AllPosts from "./AllPosts/AllPosts";
import { useStateContext } from "../../../../Context/StateContext";
import { useDispatch, useSelector } from "react-redux";
import { FilterPostListings } from "../../../../redux/posts/action";
import { getFilter } from "../../../../redux/filter/action";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getPostStingName, getSortNamePostType } from "../../../../assests/extention/commonfunction";
import OTSSearch from "../../../Common/Search/OTSSearch";

export default function SearchALL() {
  const path = "Assets/scss/FindWork.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const Thetype = searchParams.get('type');
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const {
    state,
    setProposed,
    setViewed,
    setWishlist,
    setListNull,
    setRerender,
    setSearch,
    setAllpostfiltertab,
  } = useStateContext();

  const [activeTab, setActiveTab] = useState(
    "allpost" || state?.allpostfiltertab,
  );

  useEffect(() => {
    if (state?.allpostfiltertab) {
      setActiveTab(state?.allpostfiltertab);
    } else {
      setActiveTab("allpost");
    }
  }, [state?.allpostfiltertab]);

  const toggle = (tab) => {
    if (activeTab != tab) {
      setActiveTab(tab);
      setAllpostfiltertab(tab);
      setRerender();

      switch (tab) {
        case "allpost":
          setListNull();
          break;
        case "recentview":
          setViewed();
          break;
        case "savepost":
          setWishlist();
          break;
        case "appliedpost":
          setProposed();
          break;
        default:
          break;
      }
    }
  };

  const getpostlist = useSelector(
    ({ posts: { getfilterdpost } }) => getfilterdpost,
  );

  const { pageNumber } = state;

  const dispatch = useDispatch();

  const data = {
    method: "GET",
    index: pageNumber,
    size: "10",
    type: Thetype == "4" ? 3 : Number(Thetype),
    proposed: Thetype == "4" ? 1 : state.proposed,
    viewed: state.viewed,
    wishlist: state.wishlist,
    search: state.search,
    category_id: location?.state?.similar_category_wise,
    filter: [
      {
        id: "5",
        title: "sort by",
        filter_type: "1",
        values: state?.sortByTime,
      },

      {
        id: "7",
        title: "location",
        filter_type: "3",
        values: state?.locationType,
      },
      {
        id: "8",
        title: "Industry",
        filter_type: "5",
        values: state?.industries,
      },
      {
        id: "52",
        title: "Sub Category",
        filter_type: "5",
        values: state?.subcategories,
      },
      {
        id: "48",
        title: "category",
        filter_type: "5",
        values: state?.keywords,
      },
      {
        id: "9",
        title: "skills",
        filter_type: "5",
        values: state?.specialities,
      },
      {
        id: "10",
        title: "language",
        filter_type: "2",
        values: state?.sortlanguage,
      },
      {
        id: "11",
        title: "hourly rate",
        filter_type: "7",
        min: state?.minRates?.["11"] ?? 0,
        max: state?.maxRates?.["11"] ?? 0,
      },
      {
        id: "56",
        title: "Budget",
        filter_type: "7",
        min: state?.minRates?.["56"] ?? 0,
        max: state?.maxRates?.["56"] ?? 0,
      },
      {
        id: "57",
        title: "Prize",
        filter_type: "7",
        min: state?.minRates?.["57"] ?? 0,
        max: state?.maxRates?.["57"] ?? 0,
      },
      {
        id: "58",
        title: "Weekly rates",
        filter_type: "7",
        min: state?.minRates?.["58"] ?? 0,
        max: state?.maxRates?.["58"] ?? 0,
      },
      {
        id: "59",
        title: "Monthly rates",
        filter_type: "7",
        min: state?.minRates?.["59"] ?? 0,
        max: state?.maxRates?.["59"] ?? 0,
      },
      {
        id: "60",
        title: "Hiring Type",
        filter_type: "3",
        values: state?.hiringtype,
      },
      {
        id: "61",
        title: "Country",
        filter_type: "5",
        values: state?.countries,
      },


    ],
  };

  useEffect(() => {
    dispatch(FilterPostListings(data));
    window.scrollTo({
      top: 600,
      behavior: "smooth",
    });
  }, [state, Thetype]);


  const formik = useFormik({
    initialValues: {
      search: state?.search || "",
    },
    validationSchema: Yup.object({
      // search: Yup.string()
      //   .max(500, "Must be 500 characters or less")
      //   .required("This Field is Required")
      //   .test(
      //     "not-only-spaces",
      //     "Please enter a valid value",
      //     (value) => value.trim() !== "",
      //   ),
    }),
    onSubmit: (values) => {
      setSearch(values.search);
      window.scrollTo(0, 600);
      dispatch(FilterPostListings(data));
    },
  });

  useEffect(() => {
    formik.setFieldValue("search", state.search || "", false);
  }, [state.search]);

  return (
    <div className="project-section">
      <div className="col-md-12 project1">
        <div className="col-md-6 mx-auto">
          <h2 className="font-42">
            Unlock Your Next Career Adventure. Explore Thrilling Job
            Opportunities
          </h2>
          {/* <div className="search-bar">
            <form onSubmit={formik.handleSubmit} className="w-100">
              <input
                id="search"
                name="search"
                type="search"
                placeholder={`Search ${getPostStingName(Thetype == 4 ? 3 : Thetype)}`}
                className="form-control"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.search}
              />
              {formik.touched.search && formik.errors.search ? (
                <div style={{ color: "red" }} className="error mt-2">
                  {formik.errors.search}
                </div>
              ) : null}
              <button className="btn search-btn" type="submit">
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/common/search-btn.svg`}
                  alt=""
                />
              </button>
            </form>
          </div> */}
          <OTSSearch
            state={state}
            setSearch={setSearch}
            placeholder={`Search ${getPostStingName(Thetype == 4 ? "3" : Thetype || "1")}`}
          />
          <p>Planning to hire experts? Let’s do it</p>
          <button
            onClick={() => navigate(`/${lan}/createpost`, { state: { theType: Thetype ?? "" } })}
            className="btn post-btn"
          >
            Create a post
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/project/plus.svg`}
              alt=""
            />
          </button>
        </div>
      </div>
      <div className="col-lg-10 mx-auto tab-sec">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab == "allpost" })}
              onClick={() => {
                navigate(`/${lan}/searchall?type=${Thetype == 4 ? 3 : Thetype}`)
                toggle("allpost");
              }}
            >
              All Posts ({getpostlist?.count?.count || 0})
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab == "recentview" })}
              onClick={() => {
                toggle("recentview");
              }}
            >
              Recently viewed ({getpostlist?.count?.viewed_count || 0})
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab == "savepost" })}
              onClick={() => {
                toggle("savepost");
              }}
            >
              Saved posts ({getpostlist?.count?.saved_count || 0})
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab == "appliedpost" })}
              onClick={() => {
                toggle("appliedpost");
              }}
            >
              Applied posts ({getpostlist?.count?.proposed_count || 0})
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="allpost">
            {activeTab == "allpost" && (
              <AllPosts data={data} activeTab={activeTab} />
            )}
          </TabPane>
          <TabPane tabId="recentview">
            {activeTab == "recentview" && (
              <AllPosts data={data} activeTab={activeTab} />
            )}
          </TabPane>
          <TabPane tabId="savepost">
            {activeTab == "savepost" && (
              <AllPosts data={data} activeTab={activeTab} />
            )}
          </TabPane>
          <TabPane tabId="appliedpost">
            {activeTab == "appliedpost" && (
              <AllPosts data={data} activeTab={activeTab} />
            )}
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
}
